<template>
    <div class="piece">
        <div class="piece__type">
            <img src="@/assets/icons/piece-document.png" :title="texts.document" v-if="isDocument">
            <img src="@/assets/icons/piece-good.png" :title="texts.item" v-if="!isDocument">
        </div>
        <div class="piece__params">
            <div class="piece__param">
                <div> {{texts.pieceWeightSI}}</div>
                {{piece.weight}}
            </div>
            <div class="piece__param" v-if="!isDocument">
                <div> {{texts.pieceDimensionsSI}}</div>
                {{dimensions}}
            </div>
        </div>
        <div class="piece__controls" v-if="!nonEdit">
            <button @click.prevent="onEditClick" class="button-circle">
                <span class="piece__control-img"><img src="@/assets/icons/edit.svg" alt=""></span>
                <span class="piece__control-text">{{texts.edit}}</span>
            </button>
            <button @click.prevent="onDeleteClick" class="button-circle">
                <span class="piece__control-img"><img src="@/assets/icons/cross.svg" alt=""></span>
                <span class="piece__control-text">{{texts.delete}}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'piece',
  props: {
    piece: {
      type: Object,
      required: true,
    },
    nonEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDocument() {
      return this.piece.type.type === 0;
    },
    dimensions() {
      const { width, height, depth } = this.piece.dimensions;
      return `${+width}x${+height}x${+depth} см`;
    },
    texts() {
      return {
        pieceWeightSI: this.$t('PieceWeightSI'),
        pieceDimensionsSI: this.$t('PieceDimensionsSI'),
        document: this.$t('Document'),
        item: this.$t('Item'),
        edit: this.$t('Edit'),
        delete: this.$t('Delete'),
      };
    },
  },
  methods: {
    onEditClick() {
      this.$emit('edit', this.piece);
    },
    onDeleteClick() {
      this.$emit('delete', this.piece);
    },
  },
};
</script>

<style scoped lang="scss">
    .piece {
        display: flex;
        align-items: center;
        margin: 5px;
        padding: 22px 24px;

        border-radius: 4px;
        background-color: #f0f0f0;

        &__type {
            flex: 0 0 40px;
            margin-right: 15px;
            text-align: center;
            font-size: 0;
        }

        &__params {
            display: flex;
        }

        &__param {
            margin-right: 20px;

            color: #111111;
            font-size: 15px;
            font-weight: 300;

            div {
                color: #999999;
                font-size: 11px;
                line-height: 1.4;
            }
        }

        &__controls {
            display: flex;
            margin-left: auto;
        }

        &__control {
            &-img {
                display: inline-flex;
                line-height: 1;

                img {
                    flex: 0 0 auto;
                }
            }

            &-text {
                display: none;
                color: #999999;
                font-size: 11px;
                line-height: 1;
            }
        }

        @media screen and (max-width: 769px) {
            &__control {
                &-img {
                    flex: 1 0 auto;
                    min-width: 18px;
                    justify-content: flex-end;
                }

                &-text {
                    display: inline-block;
                    margin-left: 8px;
                }
            }
        }

        @media screen and (max-width: 640px) {
            &__type {
                flex: 0 0 30px;

                img {
                    max-height: 32px;
                }
            }
        }

        @media screen and (max-width: 548px) {
            flex-wrap: wrap;

            &__controls {
                width: 100%;
                margin-top: 14px;
            }
        }
    }

    .button-circle {
        @media screen and (max-width: 769px) {
            width: auto;
            padding-left: 6px;
            padding-right: 16px;
            border-radius: 16px;
        }
    }
</style>
